export const perAgeCard = 'mt-4 mb-4 w-11/12 mx-auto bg-uiBg';
